import { render, staticRenderFns } from "./FundReporting.vue?vue&type=template&id=2e4eb674&"
import script from "./FundReporting.vue?vue&type=script&lang=js&"
export * from "./FundReporting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports